import { render, staticRenderFns } from "./PlaybackVideo.vue?vue&type=template&id=0c621b22&scoped=true&lang=pug"
import script from "./PlaybackVideo.vue?vue&type=script&lang=js"
export * from "./PlaybackVideo.vue?vue&type=script&lang=js"
import style0 from "./PlaybackVideo.vue?vue&type=style&index=0&id=0c621b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c621b22",
  null
  
)

export default component.exports